import type { FilterCommonCondition, FilterFormType, Sorter } from '@lighthouse/core'
import { useMemo } from 'react'

/**
 * fetchViewData 的依赖项类型（仅包含对象/数组类型字段）
 */
export interface FetchViewDataDeps {
    quickFiltersRule?: FilterCommonCondition[]
    resolvedFilter?: FilterFormType
    resolvedLinkFilter?: FilterFormType
    sorts?: Sorter[]
}

/**
 * 通用的 fetchViewData 依赖项管理 hook
 * 使用值比较来避免不必要的重新渲染（仅处理对象/数组类型字段）
 */
export const useFetchViewDataDeps = (deps: FetchViewDataDeps) => {
    // 创建序列化的字符串来进行值比较
    const quickFiltersRuleStr = useMemo(() => JSON.stringify(deps.quickFiltersRule), [deps.quickFiltersRule])
    const resolvedFilterStr = useMemo(() => JSON.stringify(deps.resolvedFilter), [deps.resolvedFilter])
    const resolvedLinkFilterStr = useMemo(() => JSON.stringify(deps.resolvedLinkFilter), [deps.resolvedLinkFilter])
    const sortStr = useMemo(() => JSON.stringify(deps.sorts), [deps.sorts])

    // 创建稳定的依赖对象，只有当值真正改变时才更新
    return useMemo(() => {
        return {
            quickFiltersRule: deps.quickFiltersRule,
            resolvedFilter: deps.resolvedFilter,
            resolvedLinkFilter: deps.resolvedLinkFilter,
            sorts: deps.sorts
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quickFiltersRuleStr, resolvedFilterStr, resolvedLinkFilterStr, sortStr])
}
